var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center",staticStyle:{"width":"100%","height":"100%"}},[_c('el-result',{attrs:{"icon":"warning","title":"请下载大工程师进行体验","subTitle":_vm.subTitle}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"}},[_vm._v("下载大工程师")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }